import { Component, input, output } from '@angular/core';
import { EmptyState } from '../../../../core/types/general';
import { GeneralButtonComponent } from '../general-button/general-button.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-empty-state',
  imports: [TranslateModule, MatIconModule, GeneralButtonComponent],
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.scss',
})
export class EmptyStateComponent {
  emptyConfig = input<EmptyState>();
  showButton = input<boolean>(false);

  buttonClickedEvent = output<void>();
}
